import { OEText, flex, maxHeight } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';
import { ScrollView, View } from 'react-native';

import { ClassFeedbackModalItem } from './class-feedback-modal-item';
import { useLiveClass } from '../../hooks/use-live-class';
import type { OlderLiveClassStudent } from '../../interfaces/older-live-class';

export interface ClassFeedbackModalProps {
  liveClassId: number;
}

export const ClassFeedbackModal = ({
  liveClassId,
}: ClassFeedbackModalProps) => {
  const { olderLiveClasses, sendGroupLiveClassFeedback } = useLiveClass();

  const liveClass = olderLiveClasses?.find((c) => c.id === liveClassId);

  const handleSendFeedback = async (
    feedback: string,
    student: OlderLiveClassStudent
  ) => {
    if (!liveClass) {
      return;
    }

    await sendGroupLiveClassFeedback({
      classroomId: liveClass.id,
      personId: student.id,
      feedback,
    });
  };

  if (!liveClass) {
    return null;
  }

  return (
    <Container style={maxHeight(500)}>
      <TitleContainer>
        <OEText fontSize={20}>Class Feedback - {liveClass.title}</OEText>
      </TitleContainer>
      <ScrollView>
        <View
          style={[flex('flex-row', 'flex-wrap', 'justify-content-between')]}
        >
          {liveClass.studentIdsAndNames.map((student) => (
            <ClassFeedbackModalItem
              onSendFeedback={(feedback) =>
                handleSendFeedback(feedback, student)
              }
              feedbackSent={liveClass.studentIdsAndFeedback?.some(
                (s) => s.id === student.id
              )}
              student={student}
              key={student.id}
            />
          ))}
        </View>
      </ScrollView>
    </Container>
  );
};

const Container = styled.View`
  padding: 32px;
`;

const TitleContainer = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.color.border};
  padding-bottom: 16px;
`;
